/* Elanessa: ws-ingredients behaviour. Moved out of the section's inline <script> on 2026-09-03 so it
   loads deferred and cached instead of running mid-parse. One init per root element;
   re-runs for sections added in the theme editor. */
(function () {
  function init(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var track = root.querySelector('[data-wsi-track]');

    root.querySelectorAll('[data-wsi-card]').forEach(function (card) {
      var toggle = card.querySelector('[data-wsi-toggle]');
      var panel = card.querySelector('[data-wsi-panel]');
      var close = card.querySelector('[data-wsi-close]');
      if (!toggle || !panel) return;

      // The panel animates via a transform, so it must stay in the layout —
      // toggling `hidden` (display:none) would cancel the transition and make
      // it pop. Visibility is handled in CSS, delayed until the slide finishes.
      function setOpen(open) {
        card.classList.toggle('is-open', open);
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        // preventScroll is the whole point: focusing an element inside a
        // scroll-snap track makes the browser scroll it into view, and the
        // track then re-snaps — which reads as the carousel lurching sideways
        // every time a panel opens or closes.
        if (open && close) close.focus({ preventScroll: true });
        if (!open) toggle.focus({ preventScroll: true });
      }
      toggle.addEventListener('click', function () {
        setOpen(!card.classList.contains('is-open'));
      });
      if (close) close.addEventListener('click', function () { setOpen(false); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && card.classList.contains('is-open')) setOpen(false);
      });
    });

    var dotsWrap = root.querySelector('[data-wsi-dots]');
    var slides = track ? track.querySelectorAll('.wsi-slide') : [];

    function slideStep() {
      var slide = track && track.querySelector('.wsi-slide');
      if (!slide) return track ? track.clientWidth * 0.8 : 0;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    // One dot per scroll position, not per card: with 6 cards and 4 in view
    // there are 3 places the track can stop. Matches the reference.
    function pageCount() {
      var step = slideStep();
      if (!track || !step) return 1;
      var perView = Math.round(track.clientWidth / step);
      return Math.max(1, slides.length - perView + 1);
    }

    function activeIndex() {
      var step = slideStep();
      if (!track || !step) return 0;
      return Math.min(pageCount() - 1, Math.max(0, Math.round(track.scrollLeft / step)));
    }

    var controls = root.querySelector('.wsi-controls');

    function buildDots() {
      if (!dotsWrap) return;
      var count = pageCount();
      // Nothing to scroll to: every card is already on screen, so arrows and
      // dots would be decoration. Hide the row entirely.
      var scrollable = track && track.scrollWidth > track.clientWidth + 1;
      if (controls) controls.classList.toggle('is-hidden', !scrollable || count <= 1);
      if (dotsWrap.children.length === count) return paintDots();
      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'wsi-dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to ingredient ' + (i + 1));
        dot.dataset.index = i;
        dot.addEventListener('click', function () {
          track.scrollTo({ left: slideStep() * Number(this.dataset.index), behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      }
      paintDots();
    }

    function paintDots() {
      if (!dotsWrap) return;
      var active = activeIndex();
      Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
        dot.classList.toggle('is-active', i === active);
        dot.setAttribute('aria-selected', i === active ? 'true' : 'false');
      });
    }

    function step(dir) {
      if (!track) return;
      track.scrollBy({ left: dir * slideStep(), behavior: 'smooth' });
    }

    var prev = root.querySelector('[data-wsi-prev]');
    var next = root.querySelector('[data-wsi-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { paintDots(); ticking = false; });
      }, { passive: true });
      window.addEventListener('resize', buildDots);
      buildDots();
    }
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-elanessa-init="ingredients"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
